var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2479_6725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.53 0.69873C3.37 0.69873 0 4.06873 0 8.22873C0 12.3887 3.37 15.7587 7.53 15.7587C11.69 15.7587 15.06 12.3887 15.06 8.22873C15.06 4.06873 11.7 0.69873 7.53 0.69873ZM7.53 11.6787C5.63 11.6787 4.09 10.1387 4.09 8.23873C4.09 6.33873 5.63 4.79873 7.53 4.79873C9.43 4.79873 10.97 6.33873 10.97 8.23873C10.97 10.1387 9.43 11.6787 7.53 11.6787Z",
    fill: "#4BA1DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2479_6725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.07,
    height: 15.07,
    fill: "white",
    transform: "translate(0 0.69873)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.59876d0f3e883713ab16fe34e506d2c4.svg";
export { ForwardRef as ReactComponent };